'use strict';

angular.module('cvsApp')
  .factory("userSession", ['accountDataService', 'guestDataService', 'loggerService', '$state', "loggerServiceHelper", function (AccountDataSvc, GuestDataSvc, loggerService, $state, loggerServiceHelper) {

    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setPageName("userSession") + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ABP));
    //  Session
    var _registered;
    var _accountData;
    var _effectiveDate;
    var _paymentType;
    var _selectedPaymentMethod;
    var _paymentMopType;
    var _paymentAmount;
    var _accountBalanceWidget;
    var _autoPay;
    var _pendingPayment = false;
    var _achAuthorizationRequired = false;
    var _pendingPaymentAmount;
    var _hideDrugs;
    var _guestTokenId;
    var _reviewPageAutoPay;
    var _persistValues;
    var _persistValuesCopy;
    var _paymentMethod;

    return {
      //  Authentication Status

      persit: {},
      persistCopy: {},
      postRegistrationFlow: false,

      get accountBalanceWidget() {
        return _accountBalanceWidget;
      },
      get guestTokenID() {
        return _guestTokenId;
      },
      set accountBalanceWidget(b) {
        _accountBalanceWidget = b;
      },

      get hideDrugs() {
        return _hideDrugs;
      },
      set hideDrugs(b) {
        _hideDrugs = b;
      },

      get registered() {
        return _registered;
      },
      set registered(b) {
        _registered = b;
      },


      //  Access to AutoPay config object
      get autoPay() {
        if (_accountData && _accountData.activeMop) {
          //_paymentAmount = _accountData.currentBalance;
          //_autoPay.enabled=true;
          //_paymentMethod=_accountData.activeMop.paymentMethodId;
          //_paymentMopType = _accountData.getMopById(_paymentMethod).payment.method;
          //_autoPay.schedule=_accountData.activeMop.payment.frequency && _accountData.activeMop.payment.frequency=="IMMEDIATE"?0:_accountData.activeMop.payment.frequency;
          //_autoPay.limit=_accountData.activeMop.payment.amount;
          //_paymentType="auto";*/
        } else {
          //_autoPay.enabled=false;
        }

        return _autoPay;
      },

      get reviewPageAutoPay() {
        _reviewPageAutoPay = {
          limit: _reviewPageAutoPay && _reviewPageAutoPay.limit ? _reviewPageAutoPay.limit : "333",
          frequency: _reviewPageAutoPay && _reviewPageAutoPay.frequency ? _reviewPageAutoPay.frequency : "",
          schedule: _reviewPageAutoPay && _reviewPageAutoPay.schedule ? _reviewPageAutoPay.schedule : "0"
        };
        return _reviewPageAutoPay;
      },

      //  When payment will post
      //  TODO: Possible enhancement: allow param
      //  to specify format of returned value. Or just
      //  return the base Moment object and choose the
      //  format/output when it is returned.
      get effectiveDate() {
        return _effectiveDate;
      },

      //  Payment type: "full", "partial", "auto"
      get paymentType() {
        return _paymentType;
      },
      set paymentType(t) {
        _paymentType = t;
      },

      //  This is the ACCOUNT ID of the currently Selected Payment Method
      //  Use getMopById() method to get entire MOP Object
      get selectedPaymentMethod() {
        return _selectedPaymentMethod;
      },
      set selectedPaymentMethod(m) {
        _selectedPaymentMethod = m;
        _paymentMopType = _accountData.getMopById(_selectedPaymentMethod).payment.method;
      },

      get paymentMopType() {
        return _paymentMopType;
      },

      //  Payment Amount
      get paymentAmount() {
        return _paymentAmount;
      },
      set paymentAmount(a) {
        _paymentAmount = parseFloat(a, 10);
      },

      //  The "Account" object. This will be an instance of either an
      //  AccountData.service or GuestData.service based on if the user
      //  is registered or not.
      get accountData() {
        return _accountData;
      },

      //  Add a new Method of Payment
      //  TODO: Send this to server to be saved
      addNewMop: function (account) {
        _selectedPaymentMethod = account.paymentMethodId = _accountData.generateMopId();
        _accountData.addNewMop(account);
      },

      updateMop: function (account) {
        _selectedPaymentMethod = account.paymentMethodId;
        _accountData.updateMop(account);
      },

      // Return new object for adding a new Bank or
      // credit card account. This could be moved
      // to a utiltiy module, and return specific
      // formatted object based on if MOP type will
      // be CHECK or CCARD (but they look the same
      // to me so far)
      getNewMopAccountObject: function (type) {
        return {
          "paymentMethodId": "",
          "payment": {
            "method": type,
            "frequency": type == "CHECK" ? moment().add(1, 'd').date() : "immediate",
            "amount": "",
            "fsaIndicator": "false"
          },
          "accountNumber": "",
          "routingNumber": "",
          "cardholder": {
            "firstName": "",
            "lastName": ""
          },
          "billingAddress": {
            "addressLine1": "",
            "addressLine2": "",
            "city": "",
            "state": "",
            "zipCode": ""
          },
          "expiryDate": {
            "month": "",
            "year": ""
          },
          "primaryMethod": "false",
          "activeFlag": "ACTIVE",
          "relationshipToCardHolder": "",
          "expiredIndicator": "",
          "transactionMode": "ADD"
        };
      },

      // Initialize the Session
      init: function (isRegistered, component, tokenID) {
        //  ----- Setup some defaults -----
        _guestTokenId = tokenID;
        _paymentType = "full";
        //  TODO: Build AutoPay config obj based on service response.
        //  AutoPay service isn'tavailable yet, so just setting some defaults for now.
        //  TODO: Make sure enabled is true after successful autopay setup
        _autoPay = Object.preventExtensions({
          enabled: false,
          editable: true,
          limit: 333,
          schedule: new Date().getDate() + 1
        });
        //  TODO: Fix "Effective Date" logic
        _effectiveDate = moment().format("MMM D, YYYY");

        //  ----- Initialized user's account data ---
        //  If user is Registered, load User's information
        //  set some Session defaults based on Account Data
        //  TODO: Logic for if user is registered or not
        _registered = isRegistered;
        _accountBalanceWidget = component && (component == "myAccount" || component == "RFR") ? true : false;

        /*if (_registered) {*/
        //parent.postMessage('makeOverlay', '*');
        _accountData = AccountDataSvc;
        AccountDataSvc.init(_registered, component, tokenID).then(function () {

          _paymentAmount = _accountData.currentBalance;
          _paymentMethod = _accountData.paymentMethods && _accountData.paymentMethods.length > 0 && _accountData.paymentMethods[0].paymentMethodId;
          _paymentMopType = _paymentMethod && _accountData.getMopById(_paymentMethod).payment.method;
          // _autoPay.limit = _accountData.currentBalance;
          // if (_accountData.currentBalance == "0") _autoPay.schedule = "1";
        });
        /*}else{
          _accountData = GuestDataSvc;
          GuestDataSvc.init().then(function() {
            _paymentAmount = _accountData.currentBalance;
          });
        }*/
      },

      //  Cancel current payment flow, reset defaults
      cancelPaymentFlow: function () {
        _paymentType = "full";
        if (_registered) {
          _accountData.resetMOP;
          _paymentAmount = _accountData.currentBalance;
          _paymentMethod = _accountData.paymentMethods[0].paymentMethodId;
          _paymentMopType = _accountData.getMopById(_paymentMethod).payment.method;
          _autoPay.limit = _accountData.currentBalance;
        }
      }
    };
  }]);